exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".geo-icon-custom[data-v-3f99cb66]{fill:#999;right:12px;top:50%;transform:translateY(-50%)}.geo-icon-custom[data-v-3f99cb66]:hover{fill:#333}", ""]);

// exports
